import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/circle-plus-filled/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/circle-plus-filled/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/circle-plus-filled/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconCirclePlusFilled24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Plus sign inside a circle`, id: 'icon.title.circle-plus-filled', comment: 'Title for circle plus filled icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-circle-plus-filled-24-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12m12-5.25a.75.75 0 0 1 .75.75v3.75h3.75a.75.75 0 0 1 0 1.5h-3.75v3.75a.75.75 0 0 1-1.5 0v-3.75H7.5a.75.75 0 0 1 0-1.5h3.75V7.5a.75.75 0 0 1 .75-.75" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('w-icon-circle-plus-filled-24')) {
  customElements.define('w-icon-circle-plus-filled-24', IconCirclePlusFilled24);
}